/*
  sv-gift-line (2026-09-23/24): prezent PonyGadget dodawany automatycznie jako pozycja koszyka (CEO 18.09, wariant V1).
  - dodaje domyślny wariant prezentu (właściwość _sv_gift=1), gdy w koszyku jest urządzenie z listy cart_gift_eligible_ids;
    prezent zostaje tylko wtedy, gdy rabat BXGY faktycznie zadziałał (cena < 2 % ceny) — inaczej zdjęty od razu
    i bez ponownych prób w tym koszyku (koniec promocji, kod bez łączenia z rabatami, rozjazd list produktów)
  - zdejmuje prezent (tylko linie z _sv_gift), gdy urządzeń już nie ma (także klientom hurtowym)
  - rezygnacja klientki = atrybut koszyka _sv_gift_removed=1 (widoczny w zamówieniu), pasek „Przywróć prezent”
  - zmiana koloru/rozmiaru: najpierw usuń stary wariant, potem dodaj nowy (dwa prezenty naraz = rabat obejmuje jeden)
  Konfiguracja: <script type="application/json" data-sv-gift-config> w snippets/cart-gift-banner.liquid.
  Odświeżenie: sekcje cart-drawer + cart-icon-bubble (+ sekcje strony /cart) z odpowiedzi Cart API.
  Diagnostyka: localStorage.sv_gift_debug = '1'.
  2026-09-29 (analiza porzuceń): „Realizuj zakup” czeka, aż prezent zostanie dodany/zdjęty (wcześniej szybkie kliknięcie
  = kasa bez prezentu, a widżet w kasie proponował Pony za 45 zł). Bez zmian w koszyku do zrobienia = zero opóźnienia.
*/
(function () {
  if (window.__svGiftInit) return;
  var cfgEl = document.querySelector('script[data-sv-gift-config]');
  if (!cfgEl) return;
  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  window.__svGiftInit = true;

  var M = CFG.msg || {};
  var R = window.routes || {};
  var URL_CART = (R.cart_url || '/cart') + '.js';
  var URL_ADD = (R.cart_add_url || '/cart/add') + '.js';
  var URL_UPDATE = (R.cart_update_url || '/cart/update') + '.js';
  var RETRY_DELAYS = [1000, 3000];

  var DEBUG = false;
  try {
    DEBUG = localStorage.getItem('sv_gift_debug') === '1';
  } catch (e) {}
  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[sv-gift]'].concat([].slice.call(arguments)));
  }
  var refreshes = 0;
  var verifies = 0;
  var queue = Promise.resolve();
  var syncQueued = false;
  var timer = null;
  var addFailed = false;
  var lastToken = null;
  var running = 0;
  var radioTimer = null;

  /* Wszystkie operacje na prezencie idą po kolei (jedna kolejka), żeby synchronizacja i kliknięcia się nie nakładały */
  function enqueue(fn) {
    running++;
    queue = queue
      .then(fn)
      .catch(function () {})
      .then(function () {
        running--;
      });
    return queue;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function sectionIds() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var mci = document.getElementById('main-cart-items');
    var mcf = document.getElementById('main-cart-footer');
    if (mci && mci.dataset.id) ids.push(mci.dataset.id);
    if (mcf && mcf.dataset.id) ids.push(mcf.dataset.id);
    return ids;
  }

  function post(url, body, withSections) {
    if (withSections) {
      body.sections = sectionIds();
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r
        .json()
        .catch(function () {
          return {};
        })
        .then(function (d) {
          if (!r.ok || d.status) {
            d = d || {};
            d.httpStatus = r.status;
            throw d;
          }
          return d;
        });
    });
  }

  function getCart() {
    return fetch(URL_CART, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw r;
      return r.json().then(function (cart) {
        lastToken = cart.token || lastToken;
        return cart;
      });
    });
  }

  function fetchSections() {
    return fetch((R.cart_url || '/cart') + '?sections=' + sectionIds().join(','), { cache: 'no-store' }).then(function (r) {
      return r.json();
    });
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function render(sections, focusSel) {
    if (!sections) return;
    var active = document.activeElement;
    var hadFocus = !!(active && active !== document.body && active.closest && active.closest('cart-drawer, cart-items, #main-cart-items'));
    var d = sections['cart-drawer'];
    var drawer = document.querySelector('cart-drawer');
    if (d && drawer) {
      var fresh = parse(d).querySelector('.drawer__inner');
      var cur = drawer.querySelector('.drawer__inner');
      if (fresh && cur) {
        cur.innerHTML = fresh.innerHTML;
        var empty = !!cur.querySelector('cart-drawer-items.is-empty') || !cur.querySelector('.cart-item');
        drawer.classList.toggle('is-empty', empty);
      }
    }
    var b = sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (b && bubble) {
      var bs = parse(b).querySelector('.shopify-section');
      if (bs) bubble.innerHTML = bs.innerHTML;
    }
    ['main-cart-items', 'main-cart-footer'].forEach(function (elId) {
      var el = document.getElementById(elId);
      if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
      var doc = parse(sections[el.dataset.id]);
      var src = doc.querySelector('.js-contents');
      var dst = el.querySelector('.js-contents');
      if (src && dst) dst.innerHTML = src.innerHTML;
      var srcEl = doc.getElementById(elId);
      if (elId === 'main-cart-footer' && srcEl) {
        el.classList.toggle('is-empty', srcEl.classList.contains('is-empty'));
      }
    });
    var cartItemsPage = document.querySelector('cart-items');
    var mci = document.getElementById('main-cart-items');
    if (cartItemsPage && mci && sections[mci.dataset.id]) {
      cartItemsPage.classList.toggle('is-empty', !mci.querySelector('.cart-item'));
    }
    ['main-cart-items', 'CartDrawer-CartItems'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.remove('cart__items--disabled');
    });
    if (addFailed) markFailed();
    /* fokus tylko gdy zniknął razem z przerysowaną treścią albo akcja wskazała element (tła nie przejmujemy) */
    if (hadFocus && (focusSel || !document.activeElement || document.activeElement === document.body)) {
      restoreFocus(focusSel);
      /* cart-upsell.js po przerysowaniu przenosi listę pozycji do nowego kontenera, co gubi fokus - ustaw ponownie */
      [80, 500].forEach(function (ms) {
        setTimeout(function () {
          if (!document.activeElement || document.activeElement === document.body) restoreFocus(focusSel);
        }, ms);
      });
    }
    document.dispatchEvent(new CustomEvent('sv:gift-updated'));
  }

  /* Fokus po przerysowaniu jak w motywie (CartItems.updateQuantity): wskazany element albo nazwa pierwszej pozycji */
  function restoreFocus(sel) {
    var drawer = document.querySelector('cart-drawer');
    var scope = drawer && drawer.classList.contains('active') ? drawer : document.getElementById('main-cart-items') || document;
    var el = (sel && scope.querySelector(sel)) || scope.querySelector('.cart-item__name');
    if (!el) return;
    if (drawer && scope === drawer && typeof trapFocus === 'function') trapFocus(drawer, el);
    else el.focus();
  }

  /* Komunikat dla czytników ekranu w regionach na żywo motywu (szuflada i strona /cart) */
  function announce(text) {
    if (!text) return;
    /* po chwili i z ponownym wyszukaniem elementu: przerysowanie szuflady podmienia region na nowy */
    setTimeout(function () {
      ['CartDrawer-LiveRegionText', 'cart-live-region-text'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.textContent = text;
      });
    }, 150);
  }

  function itemLabel(i) {
    if (!i) return '';
    return i.product_title + (i.variant_title ? ' – ' + i.variant_title : '');
  }

  function fill(tpl, value) {
    return (tpl || '').replace('%s', value);
  }

  function clearPending() {
    document.querySelectorAll('[data-sv-gift-pending]').forEach(function (el) {
      el.remove();
    });
  }

  /* Dodanie nie powiodło się mimo ponowień: zamiast „Dodajemy prezent…” komunikat i przycisk „Dodaj prezent” */
  function markFailed() {
    document.querySelectorAll('[data-sv-gift-add]').forEach(function (b) {
      setBtnLoading(b, false);
    });
    document.querySelectorAll('[data-sv-gift-pending]').forEach(function (row) {
      if (row.hasAttribute('data-sv-gift-failed')) return;
      row.setAttribute('data-sv-gift-failed', '');
      row.removeAttribute('aria-busy');
      var txt = row.querySelector('.sv-gift-adding');
      if (!txt) return;
      txt.textContent = M.add_failed || '';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button button--primary sv-gift-restore__btn sv-gift-retry';
      btn.setAttribute('data-sv-gift-add', '');
      btn.innerHTML = '<span></span>';
      btn.firstChild.textContent = M.add || '';
      var sp = document.querySelector('.sv-gift-restore .loading__spinner, .cart-item .loading__spinner');
      if (sp) {
        var clone = sp.cloneNode(true);
        clone.classList.add('hidden');
        btn.appendChild(clone);
      }
      txt.insertAdjacentElement('afterend', btn);
    });
  }

  function showError(row) {
    var box = row && row.querySelector('.sv-gift-error');
    if (box) {
      box.textContent = M.err || '';
      box.hidden = false;
    }
  }

  /* Rezygnacja klientki zapamiętana dla bieżącego koszyka (token) — nowy albo pusty koszyk ją kasuje */
  function getLocalRemoved(cart) {
    try {
      var v = sessionStorage.getItem('sv_gift_removed');
      if (!v) return false;
      return v === '1' || !cart || !cart.token || v === cart.token;
    } catch (e) {
      return false;
    }
  }

  function setLocalRemoved(on) {
    try {
      if (on) sessionStorage.setItem('sv_gift_removed', lastToken || '1');
      else sessionStorage.removeItem('sv_gift_removed');
    } catch (e) {}
  }

  /* Rabat nie objął prezentu: blokada dla tego koszyka, zestawu kodów rabatowych i urządzeń w koszyku
     (zmiana kodów albo urządzeń = jedna nowa próba) */
  function blockKey(cart) {
    var devices = (cart.items || [])
      .filter(isEligible)
      .map(function (i) {
        return i.variant_id;
      })
      .sort()
      .join(',');
    /* kody z koszyka (także te przypisane do pozycji) + rabaty na poziomie koszyka */
    var codes = (cart.discount_codes || [])
      .map(function (d) {
        return d.code;
      })
      .concat(
        (cart.cart_level_discount_applications || []).map(function (d) {
          return d.title;
        })
      )
      .join(',');
    return (cart.token || '') + '|' + codes + '|' + devices;
  }

  function isBlocked(cart) {
    try {
      return sessionStorage.getItem('sv_gift_block') === blockKey(cart);
    } catch (e) {
      return false;
    }
  }

  function setBlocked(cart) {
    try {
      sessionStorage.setItem('sv_gift_block', blockKey(cart));
    } catch (e) {}
    document.documentElement.classList.add('sv-gift-off');
  }

  function isGift(i) {
    return i.product_id === CFG.pid;
  }

  function isFlagged(i) {
    return isGift(i) && i.properties && i.properties._sv_gift;
  }

  /* Prezent = rabat zadziałał: cena końcowa poniżej 2 % ceny (niezależnie od waluty) */
  function isDiscounted(i) {
    return i.final_line_price * 50 < i.original_line_price;
  }

  /* Urządzenie w przedsprzedaży (pozycja z planem sprzedaży) nie daje prezentu: Shopify nie stosuje rabatu
     „Kup X, dostań Y” do przedsprzedaży (shopify.dev: purchase-options/deferred, Limitations) */
  function isEligible(i) {
    return CFG.eligible.indexOf(i.product_id) > -1 && !i.selling_plan_allocation;
  }

  function addBody(variantId) {
    return { items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _sv_gift: '1' } }] };
  }

  /* Dodanie z ponowieniem przy przeciążeniu (429) albo błędzie sieci: po 1 s i po 3 s */
  function addWithRetry(variantId) {
    var attempt = 0;
    function tryAdd() {
      return post(URL_ADD, addBody(variantId), true).catch(function (e) {
        var s = e && e.httpStatus;
        var retryable = !s || s === 429 || s >= 500;
        if (retryable && attempt < RETRY_DELAYS.length) {
          var ms = RETRY_DELAYS[attempt++];
          log('add retry in', ms, s);
          return wait(ms).then(tryAdd);
        }
        throw e;
      });
    }
    return tryAdd();
  }

  /* Wariant wyprzedany w trakcie wizyty (konfiguracja z chwili wczytania strony): odśwież dostępność z produktu
     i zwróć pierwszy dostępny wariant, żeby nie ponawiać dodania wyprzedanego */
  function refreshAvailability() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'products/' + CFG.handle + '.js';
    return fetch(url, { cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        CFG.avail = (p.variants || [])
          .filter(function (v) {
            return v.available;
          })
          .map(function (v) {
            return v.id;
          });
        if (CFG.avail.indexOf(parseInt(CFG.dv, 10)) < 0) CFG.dv = CFG.avail[0] || null;
        return CFG.dv;
      });
  }

  /* pomiar (assets/sv-cart-track.js): GA4 + dataLayer + Shopify.analytics; brak skryptu = cisza */
  function trackGift(name, line) {
    try {
      if (window.svCartTrack) window.svCartTrack(name, { color: line && line.variant_title ? line.variant_title : '' });
    } catch (e) {}
  }

  /* Dodaje prezent i sprawdza, czy rabat go objął. Nie objął → zdejmuje od razu (klientka nie widzi Pony za pełną cenę). */
  function addGiftChecked(variantId) {
    var added;
    return addWithRetry(variantId)
      .then(function (res) {
        added = res;
        return getCart();
      })
      .then(function (cart) {
        var line = findLine(cart, variantId);
        if (!line) return null;
        if (isDiscounted(line)) {
          addFailed = false;
          return { sections: added.sections, line: line };
        }
        log('gift not discounted - removing and blocking', line.final_line_price, line.original_line_price);
        /* sygnał, że rabat BXGY nie działa (np. wygasł 31.12) - widać w GA4 */
        trackGift('sv_gift_blocked', line);
        setBlocked(cart);
        var updates = {};
        updates[line.key] = 0;
        return post(URL_UPDATE, { updates: updates }, true).then(function (r) {
          return { sections: r.sections, line: null };
        });
      });
  }

  /* Doprowadza koszyk do stanu docelowego. Zwraca { sections } z odpowiedzi, gdy coś zmieniła. */
  function reconcile(cart) {
    var items = cart.items || [];
    var eligible = !CFG.b2b && items.some(isEligible);
    var gifts = items.filter(isGift);
    var flagged = items.filter(isFlagged);
    var removed = !!(cart.attributes && cart.attributes._sv_gift_removed === '1');

    var removedLocal = getLocalRemoved(cart);
    if (!eligible && removedLocal) setLocalRemoved(false);
    if (!items.length) addFailed = false;
    if (eligible && gifts.length === 0 && removedLocal && !removed) {
      /* atrybut rezygnacji zginął (nadpisany równoległym zapisem) - przywróć go zamiast dodawać prezent */
      return post(URL_UPDATE, { attributes: { _sv_gift_removed: '1' } }, true);
    }
    if (eligible && gifts.length === 0 && !removed && CFG.dv) {
      if (addFailed || isBlocked(cart)) return null;
      return addGiftChecked(lastVariant())
        .catch(function (e) {
          /* 422 = wariant wyprzedany od wczytania strony: jedna próba z pierwszym dostępnym */
          if (!e || e.httpStatus !== 422 || !CFG.handle) throw e;
          try {
            sessionStorage.removeItem('sv_gift_last');
          } catch (x) {}
          return refreshAvailability().then(function (id) {
            if (!id) throw e;
            return addGiftChecked(id);
          });
        })
        .then(function (res) {
          if (res && res.line) announce(fill(M.added, itemLabel(res.line)));
          if (res && res.line) trackGift('sv_gift_auto_add', res.line);
          return res;
        })
        .catch(function (e) {
          log('add failed', e);
          addFailed = true;
          markFailed();
          return null;
        });
    }
    if (eligible && flagged.length && !flagged.some(isDiscounted)) {
      /* prezent już w koszyku, ale rabat przestał go obejmować (np. kod bez łączenia z rabatami) - zdejmij */
      setBlocked(cart);
      var drop = {};
      flagged.forEach(function (i) {
        drop[i.key] = 0;
      });
      return post(URL_UPDATE, { updates: drop }, true);
    }
    if (!eligible && (flagged.length || removed)) {
      var updates = {};
      flagged.forEach(function (i) {
        updates[i.key] = 0;
      });
      var body = { updates: updates };
      if (removed) body.attributes = { _sv_gift_removed: '' };
      return post(URL_UPDATE, body, true);
    }
    if (eligible && flagged.length > 1) {
      var upd = {};
      /* zostaje prezent objęty rabatem (przy dwóch Shopify obejmuje rabatem tylko jeden) */
      var keep = flagged.filter(isDiscounted)[0] || flagged[0];
      flagged.forEach(function (i) {
        if (i !== keep) upd[i.key] = 0;
      });
      return post(URL_UPDATE, { updates: upd }, true);
    }
    if (eligible && flagged.length === 1 && flagged[0].quantity > 1) {
      var one = {};
      one[flagged[0].key] = 1;
      return post(URL_UPDATE, { updates: one }, true);
    }
    return null;
  }

  function sync() {
    if (syncQueued) return queue;
    syncQueued = true;
    return enqueue(function () {
      syncQueued = false;
      var blocked = false;
      return getCart()
        .then(function (cart) {
          blocked = isBlocked(cart);
          document.documentElement.classList.toggle('sv-gift-off', blocked);
          log(
            'sync',
            cart.items.map(function (i) {
              return i.product_id + ':' + i.variant_id + 'x' + i.quantity + (isFlagged(i) ? '*' : '');
            }),
            cart.attributes
          );
          return reconcile(cart);
        })
        .then(function (res) {
          if (res && res.sections) {
            log('changed');
            render(res.sections);
            /* druga weryfikacja: inne skrypty motywu zapisują koszyk równolegle i mogą nadpisać zmianę */
            if (verifies < 4) {
              verifies++;
              setTimeout(sync, 1500);
            }
            return;
          }
          verifies = 0;
          if (addFailed) {
            markFailed();
            return;
          }
          /* Nic do zmiany, ale na stronie wisi nieaktualny stan (np. starsza odpowiedź motywu nadpisała świeżą) - dorysuj aktualny */
          if (!blocked && document.querySelector('[data-sv-gift-pending], [data-sv-gift-action]') && refreshes < 3) {
            refreshes++;
            log('refresh stale DOM');
            return fetchSections().then(render);
          }
          clearPending();
        })
        .catch(function (e) {
          log('sync error', e);
          clearPending();
        });
    });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      sync();
    }, typeof ms === 'number' ? ms : 250);
  }

  /* Ładowanie jak w motywie: kręcące się kółko w wierszu zamiast ceny + zablokowana lista */
  function setBusy(row, on) {
    if (!row) return;
    row.classList.toggle('sv-gift-busy', on);
    row.querySelectorAll('.loading__spinner').forEach(function (sp) {
      sp.classList.toggle('hidden', !on);
    });
    var list = document.getElementById('CartDrawer-CartItems') || document.getElementById('main-cart-items');
    if (row.closest('#main-cart-items')) list = document.getElementById('main-cart-items');
    if (list) list.classList.toggle('cart__items--disabled', on);
  }

  function rowOf(el) {
    return el.closest('[data-sv-gift-line]');
  }

  /* Klucz pozycji zmienia się, gdy zmieniają się rabaty w koszyku, więc zawsze szukamy linii w świeżym cart.js */
  function findLine(cart, variantId) {
    var lines = (cart.items || []).filter(function (i) {
      return isGift(i) && String(i.variant_id) === String(variantId);
    });
    return lines.filter(isFlagged)[0] || lines[0] || null;
  }

  /* Zmiana wariantu: szybkie kolejne kliknięcia łączą się w jeden cel (desired); krok w kolejce czyta najnowszy wybór,
     zdejmuje WSZYSTKIE prezenty oznaczone _sv_gift (i stary wariant bez znacznika) i dodaje wybrany — nigdy dwa prezenty naraz */
  var desired = null;
  function changeVariant(row, newId, focusSel) {
    if (!row || !newId) return;
    var current = desired || row.dataset.variantId;
    if (String(newId) === String(current)) return;
    desired = String(newId);
    var rowVariant = row.dataset.variantId;
    setBusy(row, true);
    enqueue(function () {
      var want = desired;
      if (!want) return;
      return getCart()
        .then(function (cart) {
          var gifts = (cart.items || []).filter(function (i) {
            return isFlagged(i) || (isGift(i) && String(i.variant_id) === String(rowVariant) && isDiscounted(i));
          });
          if (gifts.length === 1 && String(gifts[0].variant_id) === want && isDiscounted(gifts[0])) {
            return { sections: null, line: gifts[0] };
          }
          var updates = {};
          gifts.forEach(function (i) {
            updates[i.key] = 0;
          });
          var clear = gifts.length ? post(URL_UPDATE, { updates: updates }, false) : Promise.resolve();
          return clear.then(function () {
            return addGiftChecked(want);
          });
        })
        .then(function (res) {
          if (desired !== want) return; /* nowszy wybór czeka w kolejce - przerysuje on */
          desired = null;
          if (res && res.line) rememberVariant(res.line.variant_id);
          if (res && res.line) announce(fill(M.changed, itemLabel(res.line)));
          if (res && res.line && res.sections) trackGift('sv_gift_change', res.line);
          return res && res.sections
            ? render(res.sections, focusSel)
            : fetchSections().then(function (sec) {
                render(sec, focusSel);
              });
        })
        .catch(function () {
          desired = null;
          setBusy(row, false);
          showError(row);
        });
    });
    schedule(400);
  }


  /* Wariant z opcji zaznaczonych w wierszu (kółko koloru + wciśnięty rozmiar); brak mapy albo dostępnego wariantu = wariant elementu */
  function selectedVariant(row, fallbackId) {
    var box = row.querySelector('[data-sv-gift-variants]');
    if (!box) return fallbackId;
    var variants;
    try {
      variants = JSON.parse(box.textContent);
    } catch (e) {
      return fallbackId;
    }
    var picked = {};
    row.querySelectorAll('[data-sv-gift-variant][data-sv-opt]').forEach(function (el) {
      var on = el.tagName === 'INPUT' ? el.checked : el.getAttribute('aria-pressed') === 'true';
      if (on) picked[el.dataset.svOpt] = el.dataset.svValue;
    });
    var hit = variants.filter(function (v) {
      return v.a && v.o.every(function (val, idx) {
        return picked[idx] === undefined || picked[idx] === val;
      });
    })[0];
    return hit ? String(hit.id) : fallbackId;
  }

  /* Od razu zdjęcie wybranego wariantu (nie czekamy na zapis w koszyku) */
  function showImage(row, variantId) {
    var box = row.querySelector('[data-sv-gift-variants]');
    var img = row.querySelector('.cart-item__image');
    if (!box || !img) return;
    try {
      var v = JSON.parse(box.textContent).filter(function (x) {
        return String(x.id) === String(variantId);
      })[0];
      if (v && v.img) {
        img.removeAttribute('srcset');
        img.src = v.img;
      }
    } catch (e) {}
  }

  /* Ostatnio wybrany wariant prezentu (w tej karcie) - przy przywróceniu i ponownym dodaniu wraca ten, nie domyślny */
  function lastVariant() {
    try {
      var id = sessionStorage.getItem('sv_gift_last');
      /* tylko wariant nadal dostępny; inaczej domyślny */
      return id && (CFG.avail || []).indexOf(parseInt(id, 10)) > -1 ? id : CFG.dv;
    } catch (e) {
      return CFG.dv;
    }
  }

  function rememberVariant(id) {
    try {
      sessionStorage.setItem('sv_gift_last', String(id));
    } catch (e) {}
  }

  /* Od razu pokaż wybraną wartość w linii „Kolor: …, Rozmiar: …” (zapis do koszyka idzie w tle) */
  function showValue(row, el) {
    var dd = row.querySelector('[data-sv-opt-value="' + el.dataset.svOpt + '"]');
    if (!dd || !el.dataset.svValue) return;
    var sep = /,\s*$/.test(dd.textContent) ? ', ' : '';
    dd.textContent = el.dataset.svValue + sep;
  }

  /* Kolor i rozmiar (radio): strzałki klawiatury przełączają radio co krok — zapis dopiero, gdy wybór się uspokoi */
  function onRadioChange(input) {
    var row = rowOf(input);
    if (!row) return;
    showValue(row, input);
    showImage(row, selectedVariant(row, input.value));
    clearTimeout(radioTimer);
    radioTimer = setTimeout(function () {
      radioTimer = null;
      changeVariant(row, selectedVariant(row, input.value), '[data-sv-gift-line] input[data-sv-opt="' + input.dataset.svOpt + '"]:checked');
    }, 400);
  }

  function removeGift(row) {
    verifies = 0;
    setBusy(row, true);
    var variantId = row ? row.dataset.variantId : null;
    enqueue(function () {
      return getCart()
        .then(function (cart) {
          setLocalRemoved(true);
          var line = findLine(cart, variantId);
          var body = { attributes: { _sv_gift_removed: '1' }, updates: {} };
          if (line) body.updates[line.key] = 0;
          trackGift('sv_gift_remove', line);
          return post(URL_UPDATE, body, true);
        })
        .then(function (res) {
          render(res.sections, '[data-sv-gift-restore]');
          announce(M.removed_live);
        })
        .catch(function () {
          if (row) {
            setBusy(row, false);
            showError(row);
          }
        });
    });
  }

  /* Ładowanie przycisku jak natywne „Dodaj do koszyka” motywu (product-form.js): klasa loading + spinner w przycisku */
  function setBtnLoading(btn, on) {
    btn.classList.toggle('loading', on);
    if (on) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.toggle('hidden', !on);
  }

  function restoreGift(btn) {
    setBtnLoading(btn, true);
    setLocalRemoved(false);
    addFailed = false;
    verifies = 0;
    enqueue(function () {
      return post(URL_UPDATE, { attributes: { _sv_gift_removed: '' } }, false)
        .then(getCart)
        .then(function (cart) {
          var hasGift = (cart.items || []).some(isGift);
          if (hasGift) return post(URL_UPDATE, {}, true);
          return addGiftChecked(lastVariant()).then(function (res) {
            if (res && res.line) announce(fill(M.added, itemLabel(res.line)));
            if (res && res.line) trackGift('sv_gift_restore', res.line);
            return res;
          });
        })
        .then(function (res) {
          var fs = '[data-sv-gift-line] .cart-item__name';
          return res && res.sections
            ? render(res.sections, fs)
            : fetchSections().then(function (sec) {
                render(sec, fs);
              });
        })
        .catch(function () {
          setBtnLoading(btn, false);
        });
    });
    schedule(400);
  }

  function retryAdd(btn) {
    setBtnLoading(btn, true);
    addFailed = false;
    refreshes = 0;
    verifies = 0;
    schedule(0);
  }

  /* Kasa czeka na prezent (2026-09-29). Prezent dodaje się ok. 1,5-2 s po dodaniu urządzenia (Cart API + sprawdzenie rabatu).
     Kliknięcie „Realizuj zakup” w tym czasie przechodziło do kasy bez prezentu. Teraz, gdy coś z prezentem jest w toku
     (kolejka, zaplanowana synchronizacja, zmiana koloru albo wiersz „Dodajemy prezent…”), przycisk pokazuje ładowanie jak
     w motywie i wysyła formularz koszyka dopiero po zakończeniu (najpóźniej po CHECKOUT_WAIT_MS — kasa nigdy nie jest blokowana).
     Koszyk bez zmian do zrobienia (np. prezent już jest, klientka go usunęła, przedsprzedaż, sam Pony) = zero opóźnienia. */
  var CHECKOUT_WAIT_MS = 5000;
  var checkoutWaiting = false;
  var navResetTimer = null; /* wariant B-19 */

  /* perf 2026-10 (pakiet 2, B-20): ta sama bramka dla innych operacji koszyka. window.svCheckoutHold() wstrzymuje kasę
     (np. optymistyczna szuflada w cart-drawer.js czeka na odpowiedź /cart/add) i zwraca funkcję zwalniającą.
     Kasa czeka na wszystkie wstrzymania i na prezent, dalej z tym samym limitem CHECKOUT_WAIT_MS. */
  var holds = 0;
  window.svCheckoutHold = function () {
    holds++;
    var released = false;
    return function () {
      if (released) return;
      released = true;
      holds = Math.max(0, holds - 1);
    };
  };

  function giftBusy() {
    if (holds > 0 || running > 0 || syncQueued || timer !== null || radioTimer !== null) return true;
    /* rabat nie obejmuje prezentu (blokada) albo dodanie się nie udało — nie ma na co czekać */
    if (addFailed || document.documentElement.classList.contains('sv-gift-off')) return false;
    return !!document.querySelector('[data-sv-gift-pending]:not([data-sv-gift-failed])');
  }

  /* Czeka, aż prezent się ustabilizuje; gdy wiersz „Dodajemy prezent…” wisi bez pracy w tle, uruchamia synchronizację (max 3 razy) */
  function settleGift(deadline, rounds) {
    if (!giftBusy() || Date.now() >= deadline) return Promise.resolve();
    if (!holds && !running && !syncQueued && timer === null && radioTimer === null && rounds < 3) {
      rounds++;
      sync();
    }
    /* zawsze z przerwą (bez pętli mikrozadań): koniec bieżącej kolejki i min. 150 ms, ale nigdy dłużej niż do limitu
       (perf 2026-10, test pakietu 2: wiszące żądanie Cart API trzymało kasę ponad CHECKOUT_WAIT_MS) */
    var left = Math.max(0, deadline - Date.now());
    return Promise.all([Promise.race([queue, wait(left)]), wait(Math.min(150, left))]).then(function () {
      return settleGift(deadline, rounds);
    });
  }

  /* Ładowanie jak natywny przycisk motywu (.button.loading + spinner); szuflada ma kolor tekstu w stylu inline */
  function setCheckoutLoading(on) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      if (on) {
        if (b.classList.contains('sv-co-wait')) return;
        b.classList.add('sv-co-wait', 'loading');
        b.setAttribute('aria-busy', 'true');
        b.setAttribute('data-sv-co-color', b.style.color || '');
        b.style.color = 'transparent';
        var own = b.querySelector('.loading__spinner');
        if (own) {
          own.classList.remove('hidden');
        } else {
          var sp = document.querySelector('.cart-item .loading__spinner, .sv-gift-restore .loading__spinner');
          if (sp) {
            var clone = sp.cloneNode(true);
            clone.classList.remove('hidden');
            clone.setAttribute('data-sv-co-spinner', '');
            b.appendChild(clone);
          }
        }
      } else if (b.classList.contains('sv-co-wait')) {
        b.classList.remove('sv-co-wait', 'loading');
        b.removeAttribute('aria-busy');
        b.style.color = b.getAttribute('data-sv-co-color') || '';
        b.removeAttribute('data-sv-co-color');
        var mine = b.querySelector('[data-sv-co-spinner]');
        if (mine) mine.remove();
        else if (b.querySelector('.loading__spinner')) b.querySelector('.loading__spinner').classList.add('hidden');
      }
    });
  }

  /* Wysyła formularz koszyka tak jak kliknięty przycisk (świeży element: szuflada mogła się przerysować) */
  function goCheckout(btnId, formId) {
    var btn = btnId ? document.getElementById(btnId) : null;
    var form = (btn && btn.form) || (formId ? document.getElementById(formId) : null);
    if (btn && btn.disabled) {
      setCheckoutLoading(false);
      return;
    }
    if (form && btn && btn.form === form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(btn);
      return;
    }
    if (form) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'checkout';
      h.value = '';
      form.appendChild(h);
      form.submit();
      return;
    }
    window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout';
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var co = t && t.closest ? t.closest('button[name="checkout"]') : null;
      if (!co || co.disabled) return;
      if (checkoutWaiting) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (!giftBusy()) {
        /* perf 2026-10 B-19 (pakiet 2, CEO zatwierdził 30.09), połączony z czekaniem B3: każde „Realizuj zakup” od razu pokazuje to samo
           ładowanie co przy czekaniu na prezent (1 przycisk, 1 zachowanie), a formularz jedzie do kasy bez zatrzymania.
           Gdy przejścia nie ma (np. walidacja przeglądarki), ładowanie znika po 8 s; powrót „wstecz” z kasy zdejmuje je od razu (pageshow). */
        setCheckoutLoading(true);
        clearTimeout(navResetTimer);
        navResetTimer = setTimeout(function () {
          setCheckoutLoading(false);
        }, 8000);
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      var btnId = co.id;
      var formId = co.getAttribute('form') || (co.form && co.form.id) || '';
      var started = Date.now();
      checkoutWaiting = true;
      setCheckoutLoading(true);
      log('checkout waits for gift');
      settleGift(started + CHECKOUT_WAIT_MS, 0).then(function () {
        log('checkout after', Date.now() - started, 'ms', giftBusy() ? '(limit czasu)' : '');
        checkoutWaiting = false;
        goCheckout(btnId, formId);
        /* gdy przejścia nie ma (np. walidacja formularza), przycisk wraca do normalnego stanu */
        setTimeout(function () {
          setCheckoutLoading(false);
        }, 4000);
      });
    },
    true
  );

  /* przerysowanie szuflady w trakcie czekania podmienia przycisk — ładowanie wraca na nowy element */
  document.addEventListener('sv:gift-updated', function () {
    if (checkoutWaiting) setCheckoutLoading(true);
  });

  /* Kolor i rozmiar: radio w cart-drawer-items / cart-items - zatrzymujemy "change", żeby CartItems.onChange go nie przejął */
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-sv-gift-variant]')) return;
      e.stopPropagation();
      onRadioChange(t);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var rm = t.closest('[data-sv-gift-remove]');
      if (rm) {
        e.preventDefault();
        e.stopPropagation();
        removeGift(rowOf(rm));
        return;
      }
      var rs = t.closest('[data-sv-gift-restore]');
      if (rs) {
        e.preventDefault();
        e.stopPropagation();
        if (rs.getAttribute('aria-disabled') !== 'true') restoreGift(rs);
        return;
      }
      var ad = t.closest('[data-sv-gift-add]');
      if (ad) {
        e.preventDefault();
        e.stopPropagation();
        if (ad.getAttribute('aria-disabled') !== 'true') retryAdd(ad);
      }
    },
    true
  );

  /* Shopify dzieli linię urządzenia, gdy w koszyku jest prezent (jedna sztuka „kupuje” prezent). W koszyku pokazujemy
     jedną pozycję na wariant, więc zmiana ilości ustawia linię główną i zeruje pozostałe jednym zapytaniem.
     Usunięcie ostatniego urządzenia usuwa w tym samym zapytaniu dodany automatycznie prezent (bez mignięcia 49,99 zł). */
  function wrapQuantity() {
    if (typeof CartItems === 'undefined' || CartItems.prototype.__svWrapped) return;
    var orig = CartItems.prototype.updateQuantity;
    CartItems.prototype.__svWrapped = true;
    CartItems.prototype.updateQuantity = function (line, quantity, name, variantId) {
      var self = this;
      var args = arguments;
      var row = document.getElementById('CartDrawer-Item-' + line) || document.getElementById('CartItem-' + line);
      var grouped = !!(row && row.hasAttribute('data-sv-group'));
      var giftRow = !!document.querySelector('[data-sv-gift-line]');
      if (!grouped && !(parseInt(quantity, 10) === 0 && giftRow)) return orig.apply(self, args);
      quantity = parseInt(quantity, 10) || 0;
      if (typeof self.enableLoading === 'function') self.enableLoading(line);
      enqueue(function () {
        return getCart()
          .then(function (cart) {
            var target = cart.items[line - 1];
            if (!target) {
              orig.apply(self, args);
              return;
            }
            var pj = JSON.stringify(target.properties || {});
            var updates = {};
            cart.items.forEach(function (i) {
              if (i.variant_id !== target.variant_id || JSON.stringify(i.properties || {}) !== pj) return;
              if (isGift(i) && i.quantity === 1 && isDiscounted(i)) return;
              updates[i.key] = 0;
            });
            if (quantity > 0) updates[target.key] = quantity;
            var eligibleLeft = cart.items.some(function (i) {
              var q = updates.hasOwnProperty(i.key) ? updates[i.key] : i.quantity;
              return q > 0 && isEligible(i);
            });
            var body = { updates: updates };
            if (!eligibleLeft) {
              cart.items.filter(isFlagged).forEach(function (i) {
                updates[i.key] = 0;
              });
              if (cart.attributes && cart.attributes._sv_gift_removed) body.attributes = { _sv_gift_removed: '' };
              setLocalRemoved(false);
            }
            log('quantity', line, quantity, updates);
            return post(URL_UPDATE, body, true).then(function (res) {
              render(res.sections);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: res, variantId: variantId });
              }
            });
          })
          .catch(function () {
            if (typeof self.disableLoading === 'function') self.disableLoading(line);
          });
      });
    };
  }

  function init() {
    wrapQuantity();
    /* wcześniejsza blokada w tej karcie: od razu bez wiersza „Dodajemy prezent…” (sync potwierdzi albo zdejmie) */
    try {
      if (sessionStorage.getItem('sv_gift_block')) document.documentElement.classList.add('sv-gift-off');
    } catch (e) {}
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        log('cartUpdate', evt && evt.source);
        refreshes = 0;
        verifies = 0;
        schedule(200);
      });
    }
    /* Każde przerysowanie koszyka (także ścieżkami motywu bez zdarzenia) ze znacznikiem akcji uruchamia synchronizację */
    /* reaguje tylko na NOWY znacznik (przerysowanie koszyka), nie na każdą zmianę w szufladzie (np. licznik czasu) */
    var lastMarker = null;
    var mo = new MutationObserver(function () {
      if (addFailed) markFailed();
      var m = document.querySelector('[data-sv-gift-action], [data-sv-gift-pending]:not([data-sv-gift-failed])');
      if (m && m !== lastMarker) {
        lastMarker = m;
        schedule(300);
      }
    });
    ['cart-drawer', 'cart-items'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
    if (document.querySelector('[data-sv-gift-action]')) schedule(0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    checkoutWaiting = false;
    setCheckoutLoading(false);
    schedule(0);
  });
})();
